import React from 'react';
import { ReactComponent as Logo} from '../img/logo-doneski.svg';

function Support() {
    return (
        <div className="container">
            <div className="content">
                <div className="app-logo" style={{marginLeft: '0px'}}>
                    <a href="https://www.doneski.com.au/">
                    <Logo />
                    </a>
                </div>
                <h2>Support</h2>
                <p>if you are experiencing any difficulties with the App, please contact us at <a href="mailto:support@doneski.com.au">support@doneski.com.au</a></p>
            </div>
        </div>
    );
  }

export default Support